import { useContext, useEffect, useState } from "react";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { TentantContext } from "contexts/tentant";
import { teams } from "utility";

export const TentantSelect = () => {
    const [tentant, setTentant] = useContext(TentantContext);
    const [tentantSelectList, setTentantList] = useState<Array<{ $id: string; name: string }>>([]);
    const [tentantSelected, setTentantSelected] = useState("");

    useEffect(() => {
        const fetchTentants = async () => {
            try {
                const response = await teams.list();
                const fetchedTentants = response.teams || [];
                const filteredTeams = fetchedTentants.filter(team => 
                    !team.name.toLowerCase().includes("nsw")
                  );
                setTentantList(filteredTeams);

                const storedTentant = localStorage.getItem("currentTentant");

                const validStored = fetchedTentants.find(t => t.name === storedTentant);
                const fallback = fetchedTentants[0]?.name || "";

                const finalTentant = validStored ? storedTentant! : fallback;

                setTentantSelected(finalTentant);
                setTentant(finalTentant);
                localStorage.setItem("currentTentant", finalTentant);
            } catch (err) {
                console.error("Failed to fetch tentants", err);
            }
        };

        fetchTentants();
    }, []);

    const handleChange = (event: SelectChangeEvent) => {
        const newTentant = event.target.value;
        setTentantSelected(newTentant);
        setTentant(newTentant);
        localStorage.setItem("currentTentant", newTentant);
    };

    return (
        <Select
            value={tentantSelected}
            style={{ minWidth: 180, height: 40, marginLeft: 10, marginBottom: 20 }}
            onChange={handleChange}
        >
            {tentantSelectList.map(({ $id, name }) => (
                <MenuItem key={$id} value={name}>
                    {name}
                </MenuItem>
            ))}
        </Select>
    );
};
